module.exports = __webpack_public_path__ + "img/edit.b306fb1d.svg";